import { Entity } from '../../core/data/schema/entity';

export class RRConfiguration extends Entity {

    public static className = 'RRConfiguration';
    public static idField = 'configurationId';

    configurationId: number;
    configurationKey: string;
    configurationValue: string;
    dateCreated: string;
    createdById: string;
    dateModified: string;

    public constructor(prov?: Partial<RRConfiguration>) {
        super();
        Object.assign(this, prov);
    }

    public static async getByKey(key: string) {
        return await this.getObject(RRConfiguration, 'rrconfigurations', key);
    }

    public static async fetchAll() {
        return await this.fetchArray(RRConfiguration);
    }

}
